import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { normalizarCnpj } from '@favo/core';

import { api } from './cliente';
import { chaves } from './query';
import type { EstadoCnpj, Usuario } from './tipos';

/* A regra de cadastro por CNPJ, do lado do navegador.
 *
 * A pergunta só é feita quando o CNPJ está COMPLETO (14 dígitos): perguntar a
 * cada tecla gastaria uma requisição por caractere e ainda esbarraria no limite
 * por IP da rota. Quem decide de verdade é a API — isto aqui é o aviso que
 * chega antes de a pessoa preencher o resto do formulário à toa. */

export function useEstadoCnpj(bruto: string | null | undefined) {
  const cnpj = normalizarCnpj(bruto ?? '');
  const completo = cnpj.length === 14;

  return useQuery({
    queryKey: chaves.cnpj(cnpj),
    queryFn: () => api.obter<{ estado: EstadoCnpj }>(`/integradores/cnpj/${cnpj}`),
    enabled: completo,
    // O estado de um CNPJ não muda enquanto a pessoa preenche a tela.
    staleTime: 5 * 60_000,
  });
}

type RespostaAuth = { usuario: Usuario | null };

/** Entrar na conta dona do CNPJ, ou assumir o cadastro anônimo dele. */
export function useAcessoPorCnpj(acao: 'entrar' | 'reivindicar') {
  const clienteQuery = useQueryClient();
  return useMutation({
    mutationFn: ({ cnpj, ...credenciais }: { cnpj: string; email: string; senha: string }) =>
      api
        .criar<RespostaAuth>(`/integradores/cnpj/${normalizarCnpj(cnpj)}/${acao}`, credenciais)
        .then((r) => r.usuario),
    onSuccess: (usuario) => {
      clienteQuery.setQueryData(chaves.eu, usuario);
      // Trocou de conta: todo cache era do usuário anterior.
      void clienteQuery.invalidateQueries();
    },
  });
}
